<app-header></app-header>

<div class="custom_scrollbar">
  <div>
    <section
      class="pt-5 d-table w-100"
      style="background: linear-gradient(180deg, #96c2dd, #ffffff 90%)"
    >
      <div class="container">
        <div
          class="row mt-5 align-items-center position-relative"
          style="z-index: 1; bottom: 5rem"
        >
          <div class="col-lg-6">
            <span class="badge bg-primary-subtle text-primary mb-3">
              <i class="bi bi-heart-pulse"></i> Healthcare
            </span>
            <div class="title-heading text-center text-lg-start">
              <h1
                class="fw-bold mb-3 mt-3"
                style="color: #242335; font-size: 2rem; line-height: 1.4"
              >
                Transform Hospital and Patient Experience Leveraging AI
              </h1>
              <p
                class="para-desc mx-auto mx-lg-start mb-0 ms-0"
                style="color: black"
              >
                ConnectNow empowers hospitals, clinics, and medical
                professionals with AI-driven voice, chat, and video support -
                streamlining patient interactions, reducing wait times, and
                ensuring seamless communication 24/7. It enhances the patient
                experience, automates routine queries, and provides real-time
                insights to support informed clinical and operational
                decision-making.
                <br />
              </p>
            </div>
          </div>
          <!--end col-->

          <div class="col-lg-6 mt-4 pt-2 mt-lg-0 pt-lg-0">
            <div class="card border-0 shadow rounded ms-lg-4 overflow-hidden">
              <iframe
                class="iframe w-100 rounded"
                width="560"
                height="315"
                src="https://www.youtube-nocookie.com/embed/Pt7oIfi3Da4?si=-dnf1VonvC-aa_6v&amp;controls=1&rel=0&loop=1"
                title="YouTube video player"
                frameborder="0"
                allow="
                  accelerometer;
                  autoplay;
                  clipboard-write;
                  encrypted-media;
                  gyroscope;
                  picture-in-picture;
                  web-share;
                "
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>

    <section class="d-table w-100 py-2 py-md-5">
      <div class="container">
        <div class="row" style="display: flex; flex-wrap: wrap">
          <div class="col-12 col-sm-3 p-2 d-flex">
            <div class="p-3 rounded card-box">
              <h2 style="font-weight: bold">Automate Patient Support</h2>
              <p class="para-desc mb-0">
                Reduce call center load by handling FAQs, appointments, and
                updates with AI-powered bots.
              </p>
            </div>
          </div>

          <div class="col-12 col-sm-3 p-2 d-flex">
            <div class="p-3 rounded card-box">
              <h2 style="font-weight: bold">Real-Time Operational Insights</h2>
              <p class="para-desc mb-0">
                Access dashboards that show patient flow, appointment trends,
                and wait times across units.
              </p>
            </div>
          </div>

          <div class="col-12 col-sm-3 p-2 d-flex">
            <div class="p-3 rounded card-box">
              <h2 style="font-weight: bold">Boost Patient Satisfaction</h2>
              <p class="para-desc mb-0">
                Deliver consistent, prompt responses that enhance patient trust
                and hospital reputation.
              </p>
            </div>
          </div>

          <div class="col-12 col-sm-3 p-2 d-flex">
            <div class="p-3 rounded card-box">
              <h2 style="font-weight: bold">Seamless EHR Integration</h2>
              <p class="para-desc mb-0">
                ConnectNow integrates easily with hospital systems like Cerner,
                ensuring smooth data flow.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="container-fluid pb-2 pb-md-5">
      <div class="container mb-5">
        <div class="row">
          <div class="d-flex col-md-6 p-0 px-md-2 mb-2 mb-md-0">
            <div
              class="p-3 pt-4"
              style="
                background-color: #f0f8ff;
                border-radius: 25px;
                flex: 1 1 auto;
              "
            >
              <h1
                class="fw-bold mt-0"
                style="color: #242335; font-size: 2rem; line-height: 1.4"
              >
                For Hospitals
              </h1>

              <div
                style="border-color: white"
                class="d-flex flex-column flex-md-row align-items-start rounded p-2 mb-2"
              >
                <img
                  src="assets/landing-page-v1/hospital-industry/front-desk.png"
                  alt="AI-Powered Front Desk"
                  style="object-fit: contain; height: 60px; width: 60px"
                />

                <div class="ms-0 ms-md-4">
                  <h4 class="mt-0 mb-2">AI-Powered Front Desk</h4>
                  <p class="mb-0">
                    Automate patient interactions like FAQs, bookings, and
                    directions - saving staff time.
                  </p>
                </div>
              </div>

              <div
                style="border-color: white"
                class="d-flex flex-column flex-md-row align-items-start rounded p-2 mb-2"
              >
                <img
                  src="assets/landing-page-v1/hospital-industry/command-dashboard.png"
                  alt="Unified Command Dashboard"
                  style="object-fit: contain; height: 60px; width: 60px"
                  class="p-1"
                />

                <div class="ms-0 ms-md-4">
                  <h4 class="mt-0 mb-2">Unified Command Dashboard</h4>
                  <p class="mb-0">
                    Monitor patient flow, OR activity, and service bottlenecks
                    across all hospital units.
                  </p>
                </div>
              </div>

              <div
                style="border-color: white"
                class="d-flex flex-column flex-md-row align-items-start rounded p-2 mb-2"
              >
                <img
                  src="assets/landing-page-v1/hospital-industry/patient-experience.png"
                  alt="Improved Patient Experience"
                  style="object-fit: contain; height: 60px; width: 60px"
                  class="p-1"
                />

                <div class="ms-0 ms-md-4">
                  <h4 class="mt-0 mb-2">Improved Patient Experience</h4>
                  <p class="mb-0">
                    Deliver faster, more consistent responses that enhance
                    patient satisfaction and trust.
                  </p>
                </div>
              </div>

              <div
                style="border-color: white"
                class="d-flex flex-column flex-md-row align-items-start rounded p-2"
              >
                <img
                  src="assets/landing-page-v1/hospital-industry/hospital-information-system.png"
                  alt="Secure Integration with HIS"
                  style="object-fit: contain; height: 60px; width: 60px"
                />

                <div class="ms-0 ms-md-4">
                  <h4 class="mt-0 mb-2">Secure Integration with HIS</h4>
                  <p class="mb-0">
                    Connect seamlessly with systems like Cerner, ensuring
                    real-time data sync and compliance.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex col-md-6 p-0 px-md-2">
            <div
              class="p-3 pt-4"
              style="
                background-color: #f0f8ff;
                border-radius: 25px;
                flex: 1 1 auto;
              "
            >
              <h1
                class="fw-bold mt-0"
                style="color: #242335; font-size: 2rem; line-height: 1.4"
              >
                For Patients
              </h1>

              <div
                style="border-color: white"
                class="d-flex flex-column flex-md-row align-items-start rounded p-2 mb-2"
              >
                <img
                  src="assets/landing-page-v1/hospital-industry/smart-assistance.png"
                  alt="24/7 Smart Assistance"
                  style="object-fit: contain; height: 60px; width: 60px"
                />

                <div class="ms-0 ms-md-4">
                  <h4 class="mt-0 mb-2">24/7 Smart Assistance</h4>
                  <p class="mb-0">
                    Get instant answers to your health queries through AI
                    chatbots - anytime, anywhere.
                  </p>
                </div>
              </div>

              <div
                style="border-color: white"
                class="d-flex flex-column flex-md-row align-items-start rounded p-2 mb-2"
              >
                <img
                  src="assets/landing-page-v1/hospital-industry/medical-report.png"
                  alt="Personalized Health Updates"
                  style="object-fit: contain; height: 60px; width: 60px"
                />

                <div class="ms-0 ms-md-4">
                  <h4 class="mt-0 mb-2">Personalized Health Updates</h4>
                  <p class="mb-0">
                    Receive test results, prescription reminders, and follow-up
                    alerts - all in one place.
                  </p>
                </div>
              </div>

              <div
                style="border-color: white"
                class="d-flex flex-column flex-md-row align-items-start rounded p-2 mb-2"
              >
                <img
                  src="assets/landing-page-v1/hospital-industry/track-health.png"
                  alt="Track Your Health Journey"
                  style="object-fit: contain; height: 60px; width: 60px"
                />

                <div class="ms-0 ms-md-4">
                  <h4 class="mt-0 mb-2">Track Your Health Journey</h4>
                  <p class="mb-0">
                    Get reminders, test reports, and visit summaries - all
                    delivered securely and on time.
                  </p>
                </div>
              </div>

              <div
                style="border-color: white"
                class="d-flex flex-column flex-md-row align-items-start rounded p-2"
              >
                <img
                  src="assets/landing-page-v1/hospital-industry/real-time-patient-experience.png"
                  alt="Empathetic, Real-Time Patient Experience"
                  style="object-fit: contain; height: 60px; width: 60px"
                />

                <div class="ms-0 ms-md-4">
                  <h4 class="mt-0 mb-2">
                    Empathetic, Real-Time Patient Experience
                  </h4>
                  <p class="mb-0">
                    From admission to discharge, get real-time updates; stay
                    informed about your ER or OPD queue position without the
                    anxiety of uncertainty. Know exactly where you are in the
                    discharge process to avoid unnecessary stress.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-footer></app-footer>
  <div class="fix-ui">
    <app-fixed-call></app-fixed-call>
  </div>
</div>
